var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@tanstack/react-query';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { useDefaultApiParams } from 'src/hooks';
import { useAnalyticsContext } from 'src/common/metrics/AnalyticsContext';
export const useReportAction = () => {
    const { getDefaultParams } = useDefaultApiParams();
    const rumClient = useAnalyticsContext();
    return useMutation({
        mutationFn: (_a) => __awaiter(void 0, [_a], void 0, function* ({ actionName, source }) {
            const defaultParams = getDefaultParams();
            rumClient.recordEvent('REPORT_ACTION', {
                actionName,
                source,
            });
            return yield HandshakePainterServiceApiV1.reportAction({
                actionName,
                source,
                antiCsrftokenA2z: defaultParams.antiCsrftokenA2z,
                xJoinId: defaultParams.xJoinId,
                xUserLinked: defaultParams.xUserLinked,
                marketplaceId: defaultParams.marketplaceId,
            });
        }),
    });
};
